export default{
	baseURL:'https://fin.amc-invoice.com:8443/fvm/',
 // baseURL:'https://fapiaoforceuat.taxunion.net/ei/'
	// baseURL:'http://localhost:8080/amat_fvm_war_exploded/',
	 projectType:"Amat",
	 ssoSwitch: true
}